'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002411 from "./presto.-Agent-View$$anon$11.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dError$0024 from "./presto.-Agent-View$-Error$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$10() {
  this.avw = null;
  this.avo = null;
  this.avp = false;
  this.avx = null;
  this.avy = false;
  this.avB = null;
  this.avu = null;
  this.avv = false;
  this.avq = null;
  this.avr = false;
  this.avs = null;
  this.avt = false;
  this.avz = false;
  this.avA = false;
  this.avw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.avB = "Error";
}
export { $c_Lpresto_AgentView$$anon$10 as $c_Lpresto_AgentView$$anon$10 };
$p = $c_Lpresto_AgentView$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$10;
/** @constructor */
function $h_Lpresto_AgentView$$anon$10() {
}
export { $h_Lpresto_AgentView$$anon$10 as $h_Lpresto_AgentView$$anon$10 };
$h_Lpresto_AgentView$$anon$10.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.avw;
});
$p.M = (function() {
  if ((!this.avp)) {
    this.avo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.avp = true;
  }
  return this.avo;
});
$p.O = (function() {
  if ((!this.avy)) {
    this.avx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.avy = true;
  }
  return this.avx;
});
$p.E = (function() {
  return this.avB;
});
$p.t = (function() {
  if ((!this.avv)) {
    this.avu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.avv = true;
  }
  return this.avu;
});
$p.N = (function() {
  if ((!this.avr)) {
    this.avq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.avr = true;
  }
  return this.avq;
});
$p.Q = (function() {
  if ((!this.avt)) {
    this.avs = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002411.$c_Lpresto_AgentView$$anon$11();
    this.avt = true;
  }
  return this.avs;
});
$p.v = (function() {
  if ((!this.avA)) {
    this.avz = false;
    this.avA = true;
  }
  return this.avz;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee71) => ((p) => \u03b4scrutinee71))($j_presto$002e$002dAgent$002dView$0024$002dError$0024.$m_Lpresto_AgentView$Error$())));
});
var $d_Lpresto_AgentView$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$10, "presto.AgentView$$anon$10", ({
  Dw: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$10 as $d_Lpresto_AgentView$$anon$10 };
//# sourceMappingURL=presto.-Agent-View$$anon$10.js.map
